// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.http-status-message .http-status-message--link {\n  color: #000;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
